import { render } from "./PanelTipsterTipoCompra.vue?vue&type=template&id=b8365242&scoped=true"
import script from "./PanelTipsterTipoCompra.vue?vue&type=script&lang=js"
export * from "./PanelTipsterTipoCompra.vue?vue&type=script&lang=js"

import "./PanelTipsterTipoCompra.vue?vue&type=style&index=0&id=b8365242&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8365242"]])

export default __exports__